import { BrowserInfo } from "@/utils/browser";
import { Axios } from "@/utils/axios";
import {LabelLayoutModel} from "@/models/label-layout/label-layout-model";
import {ElectronFunctions} from "@/utils/electron/electron";

class ZplPrintClass {
	// eslint-disable-next-line max-lines-per-function
	async print(zpl:string, layout:LabelLayoutModel):Promise<[]>{
		try {
			let settings = ElectronFunctions.getDefaultPrinterIdForLabelLayout(layout.ID);
			let zplSettings = layout.Data?.Data.ZplSettings;
			await Axios.post(`${BrowserInfo.getElectronUrl()}/print-zpl/print`,{host: zplSettings?.Host,port: zplSettings?.Port,zpl,device: settings.deviceId});
			return [];
		}catch (err) {
			return [];
		}
	}

}

export const ZplPrint = new ZplPrintClass();
(window as any).zplprint = ZplPrint;